import type { StoredSession } from '~/gql/sessions/sessions'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from '~/components/ConfirmDialog'

type Props = {
  session: Pick<StoredSession, 'name' | 'enrolledUsers'>
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Un parcours supprimé emporte ses inscriptions et le suivi des apprenants
 * (cascade) : le dialogue dit combien de personnes perdent leur suivi (#210).
 * Monté le temps de la confirmation seulement, comme `ModuleDeleteDialog`.
 */
function SessionDeleteDialog({ session, onConfirm, onCancel }: Props) {
  const { t } = useTranslation()
  const enrolled = session.enrolledUsers?.length ?? 0

  return (
    <ConfirmDialog
      open
      title={t('sessions.deleteTitle', { name: session.name })}
      confirmLabel={t('common.delete')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {enrolled > 0 ? t('sessions.deleteBody', { count: enrolled }) : t('sessions.deleteBodyEmpty')}
    </ConfirmDialog>
  )
}

export default SessionDeleteDialog
